import Request from "@/services/request/index";

// 获得我的考试订单列表
export const getOrderList = () => {
  return Request.get({
    url: "/exam/order/app/list",
  });
};

// 获得我的考试订单详情
export const getOrder = (params) => {
  return Request.get({
    url: "/exam/order/app/get",
    params,
  });
};

// 发起支付，返回支付跳转地址
export const createPay = (params) => {
  return Request.post({
    url: "/exam/order/app/pay",
    params,
  });
};

// 查询支付状态（主动查询交行并同步），返回是否已支付
export const queryPay = (params) => {
  return Request.get({
    url: "/exam/order/app/query-pay",
    params,
  });
};
